import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getBestPromotion = async (campaignId, couponId, price) => {
  try {
    const { data } = await Axios({
      baseURL: envConfig.partner,
      url: '/promotions/best-promotion/',
      params: { couponId, campaignId, price }
    })

    const promotionType = data.id === couponId ? 'coupon' : 'campaign'

    return { promotion: promotionType }
  } catch (error) {
    return error.response
  }
}
